import { render, staticRenderFns } from "./PrinterGroups.vue?vue&type=template&id=1a4db46c&scoped=true"
import script from "./PrinterGroups.vue?vue&type=script&lang=js"
export * from "./PrinterGroups.vue?vue&type=script&lang=js"
import style0 from "./PrinterGroups.vue?vue&type=style&index=0&id=1a4db46c&prod&lang=scss&scoped=true"
import style1 from "./PrinterGroups.vue?vue&type=style&index=1&id=1a4db46c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4db46c",
  null
  
)

export default component.exports